var _excluded = ["affixRight", "onChange", "value", "hasError", "hasWarning", "errorText", "helpText", "required", "clearBtn", "hasLocationMarker", "className", "name", "onBlur", "id", "suggestions", "noFilter", "label", "placeholder", "position", "isBlock", "inputSize", "noRecord", "noResultsItem", "onNoResultsItem", "showNoResultsItem", "utils", "attribution"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useEffect, useRef, useState } from 'react';
import Downshift from 'downshift';
import PropTypes from 'prop-types';
import nodeOfType from '../../utilities/types-of-node';
import generateId from '../../utilities/generateID';
import combineRefs from '../../utilities/combine-refs';
import FormField from '../form-field';
import Type from '../type';
import StyledAutoCompleteDropdown from './styles/autocomplete.dropdown.styles';
import StyledAutoCompleteList from './styles/autocomplete.list.styles';
import StyledAutoCompleteListItem from './styles/autocomplete.list-item.styles';
import StyledAutoCompleteDropdownInner from './styles/autocomplete.dropdown-inner.styles';
import StyledAutoComplete from './autocomplete.styles.js';
import { StyledCacheWrapper } from '../../styles';
import Icon from '../icon';
var AutocompletePropTypes = {
  /** Id of the component */
  id: PropTypes.string,
  /** Sets the name of the select within the Dropdown. */
  name: PropTypes.string,
  /** Autocomplete label */
  label: PropTypes.oneOfType([PropTypes.string, nodeOfType([Type])]),
  /** Data for autocomplete */
  suggestions: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    value: PropTypes.string.isRequired
  })), PropTypes.arrayOf(PropTypes.string)]),
  /** Boolean value to filter list of autocomplete suggestions */
  noFilter: PropTypes.bool,
  /** Show the right side cross icon in search field to clear the suggestion manually*/
  affixRight: PropTypes.array,
  /** The initial value of the autocomplete. When this value is updated, the autocomplete will update its internal model.
   * If the value is passed an object it will resolve by taking the key of value from that object. */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /** Item selection from suggestion list callback. Returns mock event object and downshift state changes */
  onChange: PropTypes.func,
  /** Blur event callback. Returns native event and current selected item */
  onBlur: PropTypes.func,
  /** Add custom CSS classes to component. */
  className: PropTypes.string,
  /** for showing a clear input button */
  clearBtn: PropTypes.bool,
  /** Text that should be displayed as the error message. */
  hasError: PropTypes.bool,
  /** Boolean value that sets whether there is a warning. */
  hasWarning: PropTypes.bool,
  /** Sets the help text of the Dropdown. */
  helpText: PropTypes.node,
  /** Placeholder text for the input */
  placeholder: PropTypes.string,
  /** Specifies a fixed position for the Dropdown list that will not adjust based on window position. */
  position: PropTypes.oneOf(['top', 'bottom']),
  /** Text to display on warning. */
  errorText: PropTypes.node,
  /** Boolean value determining if this field should be filled out as a requirement. */
  required: PropTypes.bool,
  /** Component will span the width of it's parent. */
  isBlock: PropTypes.bool,
  /** Set the width of the input based on number of characters. */
  inputSize: PropTypes.number,
  /** Takes a node. If no record is found the node will be rendered  */
  noRecord: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
  /** Text to display when no result items are returned after filtering suggestions */
  noResultsItem: PropTypes.oneOfType([PropTypes.shape({
    text: PropTypes.string,
    value: PropTypes.string
  }), PropTypes.string]),
  /** A callback function for the No Results Item */
  onNoResultsItem: PropTypes.func,
  /** Display always show "no results" message underneath the results. Must have either noRecord or noResultsItem filled in */
  showNoResultsItem: PropTypes.oneOf(['always', 'auto']),
  /** Add utility props for styling */
  utils: PropTypes.object,
  /** Handle location marker icon visibility  */
  hasLocationMarker: PropTypes.bool,
  /** Add attribution to dropdown results */
  attribution: PropTypes.node
};
var AutocompleteDefaultProps = {
  id: '',
  label: '',
  suggestions: [],
  noFilter: false,
  affixRight: [],
  value: null,
  hasError: null,
  hasWarning: null,
  clearBtn: false,
  className: '',
  name: '',
  placeholder: 'Search',
  position: null,
  errorText: '',
  helpText: '',
  required: false,
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  isBlock: true,
  inputSize: 20,
  noRecord: null,
  noResultsItem: null,
  onNoResultsItem: function onNoResultsItem() {},
  showNoResultsItem: 'auto',
  hasLocationMarker: false,
  utils: {},
  attribution: null
};

/**
 * @ignore @description
 * ## Autocomplete Component
 * The Autocomplete component is used to display a list of suggestions based on the value of what the user has typed.
 *
 * @ignore @see Mesh: [Autocomplete Docs](https://mesh-component-library.apps.csts-k8cnp-ro-1.r-caas.allstate.com/?path=/story/forms-autocomplete--default)
 *
 * @ignore @example
 * ```jsx
 * import { Autocomplete } from 'mesh-component-library';
 *
 * <Autocomplete {...props}/>
 * ```
 */

var Autocomplete = /*#__PURE__*/React.forwardRef(function (props, forwardedRef) {
  var affixRight = props.affixRight,
    onChange = props.onChange,
    value = props.value,
    hasError = props.hasError,
    hasWarning = props.hasWarning,
    errorText = props.errorText,
    helpText = props.helpText,
    required = props.required,
    clearBtn = props.clearBtn,
    hasLocationMarker = props.hasLocationMarker,
    className = props.className,
    name = props.name,
    _onBlur = props.onBlur,
    id = props.id,
    suggestions = props.suggestions,
    noFilter = props.noFilter,
    label = props.label,
    placeholder = props.placeholder,
    position = props.position,
    isBlock = props.isBlock,
    inputSize = props.inputSize,
    noRecord = props.noRecord,
    noResultsItem = props.noResultsItem,
    onNoResultsItem = props.onNoResultsItem,
    showNoResultsItem = props.showNoResultsItem,
    utils = props.utils,
    attribution = props.attribution,
    other = _objectWithoutProperties(props, _excluded);
  var autocompleteRef = useRef();
  var inputRef = useRef();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    clearBtnActive = _useState2[0],
    setClearBtnActive = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    type = _useState4[0],
    setType = _useState4[1];
  var useId = id || generateId('autocomplete_');
  var _useState5 = useState('bottom'),
    _useState6 = _slicedToArray(_useState5, 2),
    dropdownPosition = _useState6[0],
    setDropdownPosition = _useState6[1];
  var _useState7 = useState(value),
    _useState8 = _slicedToArray(_useState7, 2),
    stateValue = _useState8[0],
    setStateValue = _useState8[1];
  useEffect(function () {
    setStateValue(value);
  }, [value]);
  var handleStateChange = function handleStateChange(changes) {
    if (changes.selectedItem) {
      setClearBtnActive(true);
    } else if (changes.hasOwnProperty('inputValue')) {
      setClearBtnActive(!!changes.inputValue);
      if (changes.isOpen) {
        var _inputRef$current$get = inputRef.current.getBoundingClientRect(),
          top = _inputRef$current$get.top;
        if (position) {
          setDropdownPosition(position);
        } else {
          setDropdownPosition(top > window.innerHeight / 2 ? 'top' : 'bottom');
        }
      }
    }
  };
  var onChangeHandler = function onChangeHandler(changes, event) {
    onChange({
      target: {
        name: name,
        id: useId,
        value: changes.selectedItem || changes.inputValue
      }
    }, changes, event);
  };

  /** clear the text field value by clicking on cross icon */
  var clearInputSelection = function clearInputSelection(event) {
    onChangeHandler({
      inputValue: ''
    }, event);
    setClearBtnActive(false);
    setStateValue('');
    inputRef.current.focus();
  };

  /** Handle the keyboard and mouse changes. */
  function stateReducer(state, changes) {
    switch (changes.type) {
      case Downshift.stateChangeTypes.keyDownArrowUp:
      case Downshift.stateChangeTypes.keyDownArrowDown:
        setType('keydown');
        break;
      case Downshift.stateChangeTypes.itemMouseEnter:
        setType('mouseenter');
        break;
    }
    return changes;
  }
  var highlightText = function highlightText(text, qry, noFilterItems) {
    var index = text.toLowerCase().replace(/\n/g, ' ').indexOf(qry.toLowerCase());
    if (index < 0 || !qry || !text || noFilterItems) {
      return text;
    }
    var ln = qry.length;
    return /*#__PURE__*/React.createElement(React.Fragment, null, text.substring(0, index), /*#__PURE__*/React.createElement(Type, {
      element: "span",
      weight: "normal"
    }, text.substring(index, ln + index)), text.substring(index + ln));
  };
  var getSearchItems = function getSearchItems(inputValue, items) {
    var filteredItems = noFilter ? items : items.filter(function (item) {
      return (item.text || item).toLowerCase().replace(/\n/g, ' ').includes(inputValue.toLowerCase());
    });
    // convert to objects for consistency
    return filteredItems.map(function (item) {
      var itemObject = {
        // `original` will be returned in callback
        original: item,
        text: item.text || item,
        value: item.value || item
      };
      return _objectSpread(_objectSpread({}, itemObject), {}, {
        render: highlightText(itemObject.text, inputValue, noFilter)
      });
    });
  };

  /** To construct the suggestion list after search from input field */
  var constructSuggestionList = function constructSuggestionList(isOpen, getMenuProps, inputValue, getItemProps, highlightedIndex) {
    // search items converted to objects
    var searchItems = getSearchItems(inputValue, suggestions);
    var lastItemIsNoResultsItem = false;
    if (noResultsItem && (showNoResultsItem === 'always' || searchItems.length === 0)) {
      var itemObject = {
        original: noResultsItem,
        text: noResultsItem.text || noResultsItem,
        value: noResultsItem.value || noResultsItem
      };
      itemObject.render = /*#__PURE__*/React.createElement(Type, {
        element: "span",
        weight: "bold",
        variant: "information"
      }, itemObject.text);
      searchItems.push(itemObject);
      // the last item in the `searchItems` array is now the `noResultsItem`
      lastItemIsNoResultsItem = true;
    }
    return /*#__PURE__*/React.createElement(StyledAutoCompleteDropdown, null, isOpen && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(StyledAutoCompleteList, getMenuProps({}, {
      suppressRefError: true
    }), searchItems.map(function (item, index) {
      return /*#__PURE__*/React.createElement(StyledAutoCompleteListItem, _extends({
        highlightedIndex: highlightedIndex,
        index: index,
        type: type
      }, getItemProps({
        key: item.value,
        index: index,
        item: item,
        onClick: function onClick(event) {
          if (lastItemIsNoResultsItem && index === searchItems.length - 1) {
            onNoResultsItem(event);
          }
          onChangeHandler({
            isOpen: false,
            selectedItem: item.original
          }, event);
        }
      })), /*#__PURE__*/React.createElement(StyledAutoCompleteDropdownInner, null, item.render));
    }), noRecord && (showNoResultsItem === 'always' || searchItems.length === 0) && /*#__PURE__*/React.createElement(StyledAutoCompleteListItem, {
      noRecordFound: true
    }, noRecord))), attribution));
  };
  var itemToString = function itemToString(item) {
    if (item) {
      return _typeof(item) === 'object' ? item.value : item;
    }
    return '';
  };
  return /*#__PURE__*/React.createElement(StyledCacheWrapper, null, /*#__PURE__*/React.createElement(Downshift, {
    inputId: useId,
    onChange: setStateValue,
    onStateChange: handleStateChange,
    selectedItem: stateValue,
    ref: autocompleteRef,
    stateReducer: stateReducer,
    itemToString: itemToString,
    render: autocompleteRender
  }, function (_ref) {
    var getInputProps = _ref.getInputProps,
      getItemProps = _ref.getItemProps,
      getLabelProps = _ref.getLabelProps,
      isOpen = _ref.isOpen,
      inputValue = _ref.inputValue,
      highlightedIndex = _ref.highlightedIndex,
      selectedItem = _ref.selectedItem,
      getMenuProps = _ref.getMenuProps,
      getRootProps = _ref.getRootProps;
    return /*#__PURE__*/React.createElement(StyledAutoComplete, _extends({
      className: className,
      position: dropdownPosition,
      utils: utils
    }, getRootProps()), /*#__PURE__*/React.createElement(FormField, _extends({}, other, {
      label: label,
      ref: combineRefs(inputRef, forwardedRef),
      hasError: hasError,
      helpText: helpText,
      name: name,
      placeholder: placeholder,
      errorText: errorText,
      hasWarning: hasWarning,
      required: required,
      shape: "square",
      isBlock: isBlock,
      inputSize: inputSize,
      affixLeft: hasLocationMarker ? [{
        content: /*#__PURE__*/React.createElement(Icon, {
          icon: "map",
          color: "black",
          size: 1.25,
          alt: "Map"
        })
      }] : [],
      affixRight: clearBtn && clearBtnActive ? [{
        hollow: true,
        icon: 'cross',
        title: 'Clear values',
        color: 'blue',
        hasUpgrade: true,
        onButtonClick: clearInputSelection
      }] : affixRight
    }, getInputProps({
      onBlur: function onBlur(event) {
        _onBlur(event, selectedItem);
      },
      onChange: function onChange(event) {
        onChangeHandler({
          inputValue: event.target.value,
          isOpen: true
        }, event);
      },
      onKeyUp: function onKeyUp(event) {
        var getSearchSuggestion = suggestions.filter(function (suggestion) {
          return (suggestion.text || suggestion).includes(inputValue);
        });
        if (event.key === 'Enter') {
          onChangeHandler({
            isOpen: false,
            selectedItem: selectedItem
          }, event);
        }
        if (noResultsItem && getSearchSuggestion.length === 0 && event.key === 'Enter') {
          onNoResultsItem(event);
        }
      }
    }), {
      labelProps: getLabelProps()
    })), constructSuggestionList(isOpen, getMenuProps, inputValue, getItemProps, highlightedIndex));
  }));
});
Autocomplete.propTypes = AutocompletePropTypes;
Autocomplete.defaultProps = AutocompleteDefaultProps;
Autocomplete.displayName = 'Autocomplete';
export default Autocomplete;
export function autocompleteRender() {
  return /*#__PURE__*/React.createElement("div", null);
}